module.exports = __webpack_public_path__ + "static/outdoor2-eba23391cd45fba55c9dbcee7115ed16.jpg";